/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportType } from './ImportType';
import {
    ImportTypeFromJSON,
    ImportTypeFromJSONTyped,
    ImportTypeToJSON,
    ImportTypeToJSONTyped,
} from './ImportType';
import type { MergeMode } from './MergeMode';
import {
    MergeModeFromJSON,
    MergeModeFromJSONTyped,
    MergeModeToJSON,
    MergeModeToJSONTyped,
} from './MergeMode';
import type { FieldMapping } from './FieldMapping';
import {
    FieldMappingFromJSON,
    FieldMappingFromJSONTyped,
    FieldMappingToJSON,
    FieldMappingToJSONTyped,
} from './FieldMapping';

/**
 * 
 * @export
 * @interface ImportMapping
 */
export interface ImportMapping {
    /**
     * 
     * @type {ImportType}
     * @memberof ImportMapping
     */
    importType?: ImportType;
    /**
     * 
     * @type {{ [key: string]: Array<FieldMapping>; }}
     * @memberof ImportMapping
     */
    columnMapping?: { [key: string]: Array<FieldMapping>; } | null;
    /**
     * 
     * @type {string}
     * @memberof ImportMapping
     */
    defaultDateFormat?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportMapping
     */
    joinKeyColumn?: string | null;
    /**
     * 
     * @type {MergeMode}
     * @memberof ImportMapping
     */
    mergeMode?: MergeMode;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ImportMapping
     */
    fileJoinKeyOverrides?: { [key: string]: string; } | null;
}



/**
 * Check if a given object implements the ImportMapping interface.
 */
export function instanceOfImportMapping(value: object): value is ImportMapping {
    return true;
}

export function ImportMappingFromJSON(json: any): ImportMapping {
    return ImportMappingFromJSONTyped(json, false);
}

export function ImportMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'importType': json['importType'] == null ? undefined : ImportTypeFromJSON(json['importType']),
        'columnMapping': json['columnMapping'] == null ? undefined : json['columnMapping'],
        'defaultDateFormat': json['defaultDateFormat'] == null ? undefined : json['defaultDateFormat'],
        'joinKeyColumn': json['joinKeyColumn'] == null ? undefined : json['joinKeyColumn'],
        'mergeMode': json['mergeMode'] == null ? undefined : MergeModeFromJSON(json['mergeMode']),
        'fileJoinKeyOverrides': json['fileJoinKeyOverrides'] == null ? undefined : json['fileJoinKeyOverrides'],
    };
}

export function ImportMappingToJSON(json: any): ImportMapping {
    return ImportMappingToJSONTyped(json, false);
}

export function ImportMappingToJSONTyped(value?: ImportMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'importType': ImportTypeToJSON(value['importType']),
        'columnMapping': value['columnMapping'],
        'defaultDateFormat': value['defaultDateFormat'],
        'joinKeyColumn': value['joinKeyColumn'],
        'mergeMode': MergeModeToJSON(value['mergeMode']),
        'fileJoinKeyOverrides': value['fileJoinKeyOverrides'],
    };
}

